import { z } from "zod";

export function passwordSchema() {
    const _passwordSchema = z.string().trim().min(8, { message: "Password must be at least 8 characters long" })
        .refine(value => value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).+$/),
            {
                message:
                    "Password must contain at least one uppercase letter, " +
                    "one lowercase letter, one number, and one special character"
            });
    return z.object({
        password: _passwordSchema,
        confirmpassword: z.string(),
    })
        .refine(data => data.password === data.confirmpassword, {
            message: "Passwords do not match",
            path: ["confirmpassword"]
        });
}